import { Tag } from 'antd';
import { ScriptSource } from '../../video/model';

/** 脚本来源的展示名（与后端 `ScriptSource` 对应） */
const scriptSourceLabelMap = new Map<number, string>([
  [ScriptSource.爆款生成, '爆款生成'],
  [ScriptSource.爆款复刻, '爆款复刻'],
]);

export const ScriptSourceTag = (props: {
  source: ScriptSource | undefined;
}) => {
  const labels = [ScriptSource.爆款生成, ScriptSource.爆款复刻].flatMap(
    (flag) => {
      if (props.source == null || (props.source & flag) !== flag) {
        return [];
      }

      const label = scriptSourceLabelMap.get(flag);
      return label ? [label] : [];
    },
  );

  if (labels.length === 0) {
    return null;
  }

  return <Tag>来源：{labels.join('、')}</Tag>;
};
